export default "__VITE_ASSET__DQ9Uw1Qq__"